export const SAVE_REMOTE_USER = "save_remote_user"
export const SAVE_LOCAL_VC_DATA = "save_local_vc_data"
export const SAVE_SCREEN_SHARING_REMOTE_USER = "save_screen_sharing_remote_user"
export const REMOVE_SCREEN_SHARING_REMOTE_USER = "remove_screen_sharing_remote_user"
export const REMOVE_REMOTE_USER = "remove_remote_user"
export const UPDATE_REMOTE_USER = "update_remote_user"
export const CHANGING_USER = "changing_user"

export const CLEAR_VIDEO_CHAT_STATES = "clear_video_chat_states"